import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { Button } from '@lt/components';

import ReviewsItem from 'src/components/Reviews/ReviewsItem';
import LinkButton from '../../LinkButton';

import {
  REVEIW_MAX_HEIGHT,
  REVEIW_MAX_CONTENT_LENGTH,
  REVEIW_MAX_HEIGHT_MOBILE,
  REVEIW_MAX_CONTENT_LENGTH_MOBILE,
} from '../../../constants';

import type { PropsFromRedux as IReviewsLevelTravel } from '.';

const baseCls = 'lt-hotel-reviews';

export const ReviewsLevelTravel = ({
  items,
  showMore,
  isShowMoreVisible,
  isMobile,
  isWhitelabel,
  hotelReviewsLink,
}: IReviewsLevelTravel): JSX.Element => {
  const { t } = useTranslation();

  return items && items.length > 0 ? (
    <>
      {items.map(({ created_at, ...item }) => (
        <ReviewsItem
          {...item}
          created_at={created_at}
          key={created_at}
          maxContainerHeight={
            isMobile ? REVEIW_MAX_HEIGHT_MOBILE : REVEIW_MAX_HEIGHT
          }
          maxContentLength={
            isMobile
              ? REVEIW_MAX_CONTENT_LENGTH_MOBILE
              : REVEIW_MAX_CONTENT_LENGTH
          }
          showDate
        />
      ))}
      {isWhitelabel && isShowMoreVisible && (
        <ShowMoreContainer>
          <Button
            className={`${baseCls}__show-more-btn`}
            onClick={showMore}
            size="flex"
          >
            {t('hotel.reviews.moreReviews')}
          </Button>
        </ShowMoreContainer>
      )}
      {!isWhitelabel && isShowMoreVisible && (
        <ShowMoreContainer>
          <ShowMoreLinkButton
            href={hotelReviewsLink}
            className={`${baseCls}__show-more-btn`}
            size="flex"
          >
            {t('hotel.reviews.allReviews')}
          </ShowMoreLinkButton>
        </ShowMoreContainer>
      )}
    </>
  ) : (
    <div className={`${baseCls}__empty`}>{t('hotel.reviews.emptyTitleLT')}</div>
  );
};

const ShowMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ShowMoreLinkButton = styled(LinkButton)`
  font-size: 14px;
`;
